import { render, staticRenderFns } from "./electric.vue?vue&type=template&id=be66ff94&scoped=true"
import script from "./electric.vue?vue&type=script&lang=js"
export * from "./electric.vue?vue&type=script&lang=js"
import style0 from "./electric.vue?vue&type=style&index=0&id=be66ff94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be66ff94",
  null
  
)

export default component.exports